import React from 'react';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { withStyles } from '@material-ui/core/styles';
import { styles } from './styles';
import { connect } from 'react-redux';
import { IconButton } from '@material-ui/core';

class Header extends React.Component {
  render() {
    const { classes, story, fetching } = this.props;
    return (
      <AppBar position='fixed' className={classes.header}>
        <Toolbar variant='dense'>
          {fetching === true ? (
            <p />
          ) : (
            <IconButton>
              <ChevronLeft color='primary' />
              <Typography variant='h6' mb={1}>
                <a href={story && story.tenantURL} className={classes.tenantLink}>
                  Retourner vers {story && story.tenantName}
                </a>
              </Typography>
            </IconButton>
          )}
        </Toolbar>{' '}
      </AppBar>
    );
  }
}

const mapStateToProps = state => {
  return {
    fetching: state.storyDetailsReducer.fetching,
    story: state.storyDetailsReducer.story
  };
};

const withConnect = connect(
  mapStateToProps,
  null
)(Header);

export default withStyles(styles)(withConnect);
